

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import 'react-perfcascade/dist/react-perfcascade.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Popover from '@material-ui/core/Popover';

import styles from './styles';
import { withStyles } from '@material-ui/core/styles';

// Component styles
import { api_host , api_auth} from '../../../../../common/globals/constants';
import image from '../../../../../icons/play_audio.png';
import Audio from '../../../../../helpers/Audio';
import AudioPatternElement from '../AudioPatternElement';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

class AudioElement extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            isLoad: true,
            objective: this.props.objective,
            nodes: this.props.nodes,
            steps: this.props.steps,
            begin: this.props.dateBegin.format("YYYY-MM-DD H:mm:ss"),
            final: this.props.dateFinal.format("YYYY-MM-DD H:mm:ss"),
            dates: null,
            modalOpen:false,
            monitors: this.props.monitors,
            node: this.props.node,
            anchorEl: null,
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dateBegin.format("YYYY-MM-DD H:mm:ss") !== state.begin||props.dateFinal.format("YYYY-MM-DD H:mm:ss")!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin.format("YYYY-MM-DD H:mm:ss"),
                final:props.dateFinal.format("YYYY-MM-DD H:mm:ss"),
                dates:null
            }
        }
        if(props.node!== state.node){
            return {
                isLoad:true,
                nodes: props.nodes,
                monitors: props.monitors,
                node: props.node
            }
        }
        
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevProps.dateBegin.format("YYYY-MM-DD H:mm:ss")!== this.state.begin
            || prevProps.dateFinal.format("YYYY-MM-DD H:mm:ss")!== this.state.final
            || prevProps.node!== this.state.node){
            this.processData();
        }
    }
    

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, begin, final, monitores, token) =>{
        return new Promise((resolve, reject) => {
            var cdnList = []
            var fetches = []            
            monitores.forEach((value, key)=>{
                var monitor_id = (value)
                var getListAudios = fetch(api_host+`/reporte/general/objetivos/${objective}/audios_ivr/list_audios/?token=${token}&fecha_inicio=${begin}&fecha_termino=${final}&monitor=${monitor_id}`)
                        .then( response => response.json())
                fetches.push(                    
                    getListAudios.then( dataCdn =>  { 
                            cdnList[key] = dataCdn;
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(cdnList);
            })      
        });
    }

   
    processData = () => {
        const { objective, nodes, begin, final, monitors, node} = this.state
        let token = sessionStorage.getItem('key')
        let listAudio = []
        fetch(api_host+`/reporte/online/indicadores/getResultadosObjetivoLigero/?objetivoId=${objective}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&fecha_inicio=${begin}&fecha_termino=${final}&nodoId=${node}`)
                .then(response => response.json())
                .then(myJson => { 
                        var listMonitor = monitors
                        if (node != 0){
                            listMonitor = []
                            Object(nodes).map(element=>{
                                if (element['id_nodo'] == node){
                                    listMonitor.push(element['monitor'])
                                }
                            })
                        }
                        var listDates = []
                        let nodesStatus = myJson.Objetivo.Nodo
                        var fetchListAudios = this.getFetchs(objective, begin, final, listMonitor, token)
                        fetchListAudios.then( value =>{
                            Object(value).map(element=>{
                                if (element.length > 0){
                                    Object(element).map(data=>{
                                        listAudio.push(data)
                                    })
                                }
                            })
                            listAudio.sort(function (a, b) {
                                const aDate = new Date(a.fecha)
                                const bDate = new Date(b.fecha)
                                return bDate.getTime() - aDate.getTime()
                            });
                            Object(listAudio).map(element=>{
                                var dictDates = {}
                                dictDates['fecha'] = element.fecha
                                dictDates['fecha_tz'] = element.fecha_tz
                                Object(nodes).map(node=>{
                                    if(node['monitor'] == element['monitor_id']){
                                        dictDates['nodo'] =  node['nodo']
                                        element['nodo'] = node['nodo']
                                        Object(nodesStatus).map(nodeStatus=>{
                                            if (nodeStatus['nodo_id'] == node['id_nodo']){
                                                var index = 0
                                                Object(nodeStatus['Paso']).map(stepStatus=>{
                                                    var pattern = null
                                                    
                                                    if (stepStatus['orden'] == element['paso_orden']){
                                                        element['paso_nombre'] = stepStatus['paso_nombre']
                                                        Object(stepStatus['Eventos']).map(eventStatus=>{
                                                            var color = ''
                                                            pattern = eventStatus.patron
                                                            const dateEventStatus = new Date(eventStatus.fecha.substr(0,19))
                                                            const dateElement = new Date(element.fecha_tz.substr(0,19))
                                                            if (dateElement.getTime() - dateEventStatus.getTime() > -1000){
                                                                
                                                                if(eventStatus['código_tipo'] == 0){
                                                                    color = '#A9A9A9'
                                                                }else if(eventStatus['código_tipo'] == 1) {
                                                                    color = '#41B900'
                                                                }else if(eventStatus['código_tipo'] == 2) {
                                                                    color = '#C2272D'
                                                                }
                                                                element['status'] = eventStatus['código_tipo']
                                                                element['color'] = color
                                                                element['pattern'] = pattern
                                                                element['patron'] = null
                                                            }
                                                        })
                                                    }
                                                    index = index + 1
                                                })
                                            }
                                        })
                                    }
                                })
                                listDates.push(dictDates)
                            })
                            var uniqueItems = listDates.filter((v,i,a)=>a.findIndex(t=>(t.fecha === v.fecha))===i)
                            
                            this.props.callbackFromParent(true)
                            var isEmpty = false
                            this.setState({ isOpen: !this.state.isOpen,
                                            //target: targetEvent,
                                            currentDate: begin,
                                            //currentNode: currentNode,
                                            listAudio: listAudio,
                                            listDates: uniqueItems,
                                            isLoad: false,
                                            dates: value});
                        })

                })
        
    }

    setOpen = (audio) => {
        this.setState({
            modalOpen : true,
            modalClose : false,
            setAudio : audio,
        })
    }
    setCloseModal=()=>{
        this.setState({
            modalOpen : false,
            modalClose : true,
            setAudio : null
        })
    }

    /*setOpenPattern = () => {
        this.setState({
            modalOpenPattern : true,
            modalClosePattern : false,
            //setAudio : audio,
        })
    }*/
    setOpenPattern = event => {
        this.setState({
            anchorEl: event.currentTarget
        });
    };
    setCloseModalPattern=()=>{
        this.setState({
            anchorEl: null,
            modalOpenPattern : false,
            modalClosePattern : true,
            //setAudio : null
        })
    }

    render() {

        const { isLoad, dates, steps, objective, listAudio, modalOpen, 
            listDates, begin, final, nodes, monitors, anchorEl} = this.state;
        const modalOpenPattern = Boolean(anchorEl);
        const { classes } = this.props;
        if (isLoad===true) {
            return(
                <div className={classes.chart}>
                    <Typography
                        variant="caption"
                        align="center"
                        style={{color:'white'}}
                    >
                        <CircularProgress
                            variant="indeterminate"
                            size={12}
                            thickness={3}
                        />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return(
                <PortletContent>
                    <Button onClick={this.setOpenPattern} style={{backgroundColor:'#FF5733', color:'white', fontFamily:'Roboto', float:'right'}}>Patrones </Button>
                    {listDates.map(date=>{
                            return(
                                <div key={date['nodo']+'    '+date['fecha_tz'].substr(0,19).replace('T',' ')}>
                                    <PortletHeader style={{backgroundColor:'#525252', color:'white', fontFamily:'Roboto'}}>
                                        {date['nodo']+'    '+date['fecha_tz'].substr(0,19).replace('T',' ')}
                                    </PortletHeader>
                                    <PortletContent style={{backgroundColor: '#a2a2a2'}} >
                                        <PerfectScrollbar > 
                                            <Table>
                                                <TableBody>
                                                    <TableRow
                                                        //direction="row"
                                                        //container
                                                        //spacing={2}
                                                        //justify="flex-start"
                                                        style={{textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: "normal",
                                                        wordWrap: "break-word",
                                                        width: '500% !important',}}
                                                    >
                                                        {listAudio.map(audio=>(
                                                            date['fecha'] == audio['fecha'] ?
                                                                <TableCell >
                                                                    <div style={{border: '4px solid #ddd', borderColor: audio['color'], width: '164px'}}>
                                                                        <Typography style={{backgroundColor: audio['color'], color:'white', width: '160px', padding: '5px'}}>{audio['paso_nombre']}</Typography>
                                                                        <Button onClick={(e)=>{this.setOpen(audio)}}>
                                                                            <img style={{ padding: '1px', width: '140px', height:'100px'}} src={image} />
                                                                        </Button>
                                                                        {/*<Button style={{backgroundColor: audio['color'], color:'white', width: '160px', padding: '5px'}}>
                                                                            descargar audio
                                                                        </Button>*/}
                                                                    </div>
                                                                </TableCell>
                                                            : null
                                                        ))}
                                                            
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </PerfectScrollbar>
                                    </PortletContent>
                                </div>
                            )
                        }
                    )}
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpen}
                        onClose={this.setCloseModal}
                        style={{
                            //maxHeight:'40vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                    >
                        <Fade in={modalOpen}>
                            <Audio data = {this.state}  onClose={this.setCloseModal}/>
                        </Fade>
                    </Modal>

                   
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={modalOpenPattern}
                        onClose={this.setCloseModalPattern}
                        style={{
                            //maxHeight:'40vh',
                            //maxWidth:'40vw',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'visible !important',
                            position: 'fixed',
                            paddingTop: '30vh',
                        }}
                        //contentStyle={{maxWidth: 300}}
                        disableAutoFocus={true}
                        disableEnforceFocus={true}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 100,
                        }}               
                    >
                        <Fade in={modalOpenPattern}>
                            <PerfectScrollbar>
                                <AudioPatternElement onClose={this.setCloseModalPattern} monitors={monitors} nodes={nodes} objective={objective} steps={steps} dateBegin={begin} dateFinal={final}/>
                            </PerfectScrollbar>
                        </Fade>
                    </Modal>
                </PortletContent>
            )
        }
    }
}

export default compose(withRouter, withStyles(styles))(AudioElement);